
import {
    ADD_PROSPECT_BUSINESS_ENTITY,
    ADD_PROSPECT_BUSINESS_ENTITY_SUCCESS,
    ADD_PROSPECT_BUSINESS_ENTITY_ERROR,
    UPDATE_PROSPECT_BUSINESS_ENTITY,
    UPDATE_PROSPECT_BUSINESS_ENTITY_SUCCESS,
    UPDATE_PROSPECT_BUSINESS_ENTITY_ERROR,
    DELETE_PROSPECT_BUSINESS_ENTITY,
    DELETE_PROSPECT_BUSINESS_ENTITY_SUCCESS,
    DELETE_PROSPECT_BUSINESS_ENTITY_ERROR,

} from "./actionTypes"
// addLeadBusinessEntity
export const addProspectBusinessEntity = payload => {
    return {
        type: ADD_PROSPECT_BUSINESS_ENTITY,
        payload: payload,
    }
}

// addLeadBusinessEntitySuccess
export const addProspectBusinessEntitySuccess = prospect => {
    return {
        type: ADD_PROSPECT_BUSINESS_ENTITY_SUCCESS,
        payload: prospect,
    }
}

// addLeadBusinessEntityError
export const addProspectBusinessEntityError = error => {
    return {
        type: ADD_PROSPECT_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}

// updateLeadBusinessEntity
export const updateProspectBusinessEntity = payload => {
    return {
        type: UPDATE_PROSPECT_BUSINESS_ENTITY,
        payload: payload,
    }
}

// updateLeadBusinessEntitySuccess
export const updateProspectBusinessEntitySuccess = prospect => {
    return {
        type: UPDATE_PROSPECT_BUSINESS_ENTITY_SUCCESS,
        payload: prospect,
    }
}

// updateLeadBusinessEntityError
export const updateProspectBusinessEntityError = error => {
    return {
        type: UPDATE_PROSPECT_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}

// deleteLeadBusinessEntity
export const deleteProspectBusinessEntity = payload => {
    return {
        type: DELETE_PROSPECT_BUSINESS_ENTITY,
        payload: payload,
    }
}

// deleteLeadBusinessEntitySuccess
export const deleteProspectBusinessEntitySuccess = prospect => {
    return {
        type: DELETE_PROSPECT_BUSINESS_ENTITY_SUCCESS,
        payload: prospect,
    }
}

// deleteLeadBusinessEntityError
export const deleteProspectBusinessEntityError = error => {
    return {
        type: DELETE_PROSPECT_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}
